<template>
  <v-row v-if="ready" class="pt-5">
    <v-col cols="10" offset="1">
      <v-row v-if="summaryMode == 'popular'">
        <v-col cols="12">
          <h2>Most featured</h2>
          <bar-graph :id="`graph-summary-bar`" :data="filteredList" />
        </v-col>
      </v-row>

      <v-row v-if="summaryMode == 'choice'">
        <v-col cols="12">
          <h2>By choice</h2>
        </v-col>
        <v-col
          cols="6"
          v-for="(group, index) in grouped"
          :key="`group-${index}`"
        >
          <h4>{{ getChoice(index) }}</h4>
          <bar-donought :id="`graph-${index}`" :data="getSubGroup(group)" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import lodash from "lodash";
import { mapState } from "vuex";
// import { store } from "@/store.js";
import { BarDonought, BarGraph } from "@/components/graphs";
export default {
  name: "ResultsFunctionalitySummary",
  data() {
    return {
      doc: null,
      intervalId: null,
      ready: false,
      max: 0,
      functionality: [],
    };
  },
  components: {
    BarDonought,
    BarGraph,
  },
  props: {
    id: String,
    summaryMode: {
      type: String,
      default: "combined",
    },
  },
  mounted() {
    this.getList();
    this.init();
  },
  computed: {
    ...mapState(["exFunctionality"]),
    filteredList() {
      let items = [];
      let distribution = this.exFunctionality.reduce(
        (acum, cur) =>
          Object.assign(acum, { [cur.id]: (acum[cur.id] | 0) + 1 }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        item.title = this.getTitle(item.el);
        item.percentage = this.getPercentage(item.count);
      });
      return items;
    },
    filteredSort() {
      return lodash.orderBy(this.filteredList, "count", "desc");
    },
    unit() {
      return this.max / 100;
    },
    grouped() {
      return lodash.groupBy(this.exFunctionality, "index");
    },
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (this.exFunctionality && this.functionality) {
        this.setMax();
        this.ready = true;
        clearInterval(this.intervalId);
      }
    },
    getSubGroup(group) {
      let items = [];
      let distribution = group.reduce(
        (acum, cur) =>
          Object.assign(acum, { [cur.id]: (acum[cur.id] | 0) + 1 }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        item.title = this.getTitle(item.el);
        item.percentage = this.getPercentage(item.count);
      });
      return items;
    },
    setMax() {
      this.max = Math.max.apply(
        null,
        this.filteredList.map((item) => item.count)
      );
      console.log("max=", this.max);
    },
    getList() {
      let ref = fb.functionalityBetaCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.functionality = items;
          }
        })
        .catch(function() {});
    },
    getTitle(id) {
      let tile = this.functionality.find((item) => item.id === id);

      return tile ? tile.title : null;
    },
    getPercentage(count) {
      let unit = 100 / this.max;
      return unit ? `${count * unit}%` : null;
    },
    getChoice(index) {
      switch (parseInt(index)) {
        case 0:
          return "1st choice";
        case 1:
          return "2nd choice";
        case 2:
          return "3rd choice";
        case 3:
          return "4th choice";
        case 4:
          return "5th choice";
        case 5:
          return "6th choice";
        default:
          return "";
      }
    },
  },
};
</script>
